export default __webpack_public_path__ + "static/media/aws.c8f49c4d.svg";